import React , {Component} from 'react';
import Stars from '../../assets/images/Stars.svg';


export default class Orders extends Component{
    // constructor(){
    //     super()
    // }

    render(){
        return(
            <div>
            <div className="container-fluid">
            <div className="orders-main-div">
            <div className="row">
           {/* <div className="col-md-12 col-lg-12">
            <div className="row" style={{marginLeft:'0'}}>
            <div className="" >
            <h4>Orders</h4>
            </div>
           
            <div className="orders-head-line display-none"></div>
            <p class="display-none">View all</p>
            <i class="fa fa-arrow-right orders-head-arrow" aria-hidden="true"></i>
            </div>
            </div>
        */}
            <div className="col-md-12 col-lg-12">
            <div className="orders-list-div">
            <div className="row">
            <div className="col-sm-2 col-md-2 col-lg-2">
            <div className="orders-stars">
            <img src={Stars}  alt="...."/>
            </div>
            </div>
            <div className="col-sm-10 col-md-10 col-lg-10">
            <div className="orders-list-content"> <p>Kinship helps in keeping you mentally and socially active</p></div>
            <div className="orders-list-btn">
            {
                localStorage.getItem('current_user_id') !== undefined && localStorage.getItem('current_user_id') !== null && localStorage.getItem('current_user_id') !== '' ?
                <button className="btn" type="button" onClick={()=>this.props.HandleRouting('booked-sessions')}>My Booked Sessions</button>
                :
                <button className="btn" type="button" onClick={()=>this.props.HandleRouting('login')}>My Booked Events</button>
            }
            
            <button className="btn" type="button" onClick={()=>this.props.HandleRouting('upcoming-sessions')}>Upcoming Sessions</button>
            <button className="btn" type="button" onClick={()=>this.props.HandleRouting('travel')}>Upcoming Tours</button>
            <button className="btn" type="button" onClick={()=>this.props.HandleRouting('home')}>See all</button>
            
            </div>
            
            </div>
            </div>
            </div>
            </div>
            <div className="col-md-12 col-lg-12">
            <div className="orders-list-seperation-line"></div>
            </div>
            </div>
            
            </div>
            </div>
            </div>
        )
    }
}